import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AssetsService } from '@sc/data-access-assets';
import { LocationData } from '@sc/data-access-models';
import { FocusManagerService } from '@sc/feature-focus-manager';
import {
  ButtonComponent,
  CustomValidators,
  InputTextComponent,
} from '@sc/ui-components';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'sc-search-location-bottom-sheet',
  styleUrls: ['./search-location-bottom-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    InputTextComponent,
    ButtonComponent,
    TranslateModule,
  ],
  template: `
    <div class="content" [formGroup]="form">
      <p id="find-address-title" class="sc-design-text-3-bold">
        {{ 'SearchLocationBottomSheet.findAdressTitle' | translate }}
      </p>

      <sc-input-text
        formControlName="address"
        autocomplete="street-address"
        [suggestions]="_locationSuggestions"
        [forceHighlightRequired]="false"
        ariaDescribedby="find-address-title"
        suggestionsLabelName="address"
        (updateSuggestions)="onAddressChange($event)"
        (selectSuggestion)="onSelectAddress($event)"
        [label]="
          'CustomerDeclaration.AppointmentSearchPage.searchAddressInput'
            | translate
        "
      ></sc-input-text>
      <sc-button
        buttonType="primary"
        [disabled]="!form.valid"
        (click)="onSelectAddress(_locationSuggestions[0])"
        >{{ 'SearchLocationBottomSheet.search' | translate }}</sc-button
      >
      <sc-button buttonType="tertiary" (click)="onCancel()"
        >{{ 'SearchLocationBottomSheet.cancel' | translate }}
      </sc-button>
    </div>
  `,
})
export class SearchLocationBottomSheetComponent implements AfterViewInit {
  _locationSuggestions = [];

  @Input() set locationSuggestions(locationSuggestions: LocationData[]) {
    this._locationSuggestions = locationSuggestions;
    this.isLoadingSuggestions$.next(false);
    this.isLoadingSuggestions$.next(true);
  }

  isLoadingSuggestions$ = new BehaviorSubject<boolean>(true);

  form: FormGroup = new FormGroup({
    address: new FormControl(
      '',
      [Validators.required],
      [
        CustomValidators.atLeastOneSuggestion(
          this.isLoadingSuggestions$,
          () => this._locationSuggestions
        ),
      ]
    ),
  });

  @Output() cancelEvent = new EventEmitter<void>();
  @Output() choseAddressManually = new EventEmitter<void>();
  @Output() valueChange = new EventEmitter<string>();
  @Output() addressSelected = new EventEmitter<LocationData>();

  constructor(
    public assetsService: AssetsService,
    private readonly focusManager: FocusManagerService
  ) {}

  ngAfterViewInit(): void {
    this.focusManager.focusFirstElementAllowed(
      'sc-search-location-bottom-sheet sc-input-text',
      true
    );
  }

  onCancel(): void {
    this.cancelEvent.emit();
  }

  onAddressChange(value: string) {
    this.valueChange.emit(value);
  }

  onSelectAddress(location: LocationData) {
    if (location) {
      this.addressSelected.emit(location);
    }
  }
}
